// extracted by mini-css-extract-plugin
export default {"Pagination":"_Pagination--xDCl7","WithoutPages":"_WithoutPages--u21eh","Buttons":"_Buttons--JM12V","ArrowButton":"_ArrowButton--qBchQ","ArrowIcon":"_ArrowIcon--Pw_ry"};